import { render, staticRenderFns } from "./AamsGiftRegSubmissionDetail.vue?vue&type=template&id=5da9e872&scoped=true&"
import script from "./AamsGiftRegSubmissionDetail.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegSubmissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./AamsGiftRegSubmissionDetail.vue?vue&type=style&index=0&id=5da9e872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9e872",
  null
  
)

export default component.exports